import { render, staticRenderFns } from "./avatar-icon.vue?vue&type=template&id=86044e6e&"
import script from "./avatar-icon.vue?vue&type=script&lang=js&"
export * from "./avatar-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports